import { cn } from "@/lib/utils";

const KEYS: { digit: string; letters?: string }[] = [
  { digit: "1" },
  { digit: "2", letters: "ABC" },
  { digit: "3", letters: "DEF" },
  { digit: "4", letters: "GHI" },
  { digit: "5", letters: "JKL" },
  { digit: "6", letters: "MNO" },
  { digit: "7", letters: "PQRS" },
  { digit: "8", letters: "TUV" },
  { digit: "9", letters: "WXYZ" },
  { digit: "*" },
  { digit: "0", letters: "+" },
  { digit: "#" },
];

interface KeypadProps {
  onDigit: (digit: string) => void;
  /**
   * `widget` (default): dark in-call widget treatment.
   * `surface`: theme-aware treatment for dialogs/pages.
   */
  variant?: "widget" | "surface";
}

/** DTMF / dialer keypad. */
export function Keypad({ onDigit, variant = "widget" }: KeypadProps) {
  const widget = variant === "widget";
  return (
    <div className="grid grid-cols-3 gap-1.5" role="group" aria-label="Dial pad">
      {KEYS.map((key) => (
        <button
          key={key.digit}
          type="button"
          onClick={() => onDigit(key.digit)}
          aria-label={`Dial ${key.digit}`}
          className={cn(
            "flex flex-col items-center justify-center rounded-lg transition-colors",
            widget
              ? "h-11 bg-white/5 hover:bg-white/10 active:bg-white/15"
              : "h-12 bg-muted/60 hover:bg-muted active:bg-muted/80",
          )}
        >
          <span
            className={cn(
              "text-base font-medium leading-none",
              widget ? "text-zinc-50" : "text-foreground",
            )}
          >
            {key.digit}
          </span>
          {key.letters ? (
            <span
              className={cn(
                "mt-0.5 text-[8px] leading-none tracking-[0.2em]",
                widget ? "text-zinc-500" : "text-muted-foreground",
              )}
            >
              {key.letters}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
